module.exports = __webpack_public_path__ + "img/history.b4cbd78d.png";